import React from 'react';
import styled from 'styled-components';
import bg from '../../../styles/images/hero-banner-bg.png';

const StyledWrap = styled.div`
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bg});
  width: 100%;
  height: 598px;
  left: 0;
  background-repeat: no-repeat;
  background-color: #ccc;
  background-size: cover;
  background-position: 40% 100%;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    height: 540px;
  }
`;

const HeroBackground = () => <StyledWrap />;

export default HeroBackground;



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/HeroBackground.js